export type TimetableSource = "profile" | "timetables";

export function studentTimetablePath(
	studentNo: number,
	source: TimetableSource = "profile",
) {
	return source === "timetables"
		? `/timetables/student/${studentNo}`
		: `/students/${studentNo}/timetable`;
}

export function staffTimetablePath(
	initials: string,
	source: TimetableSource = "profile",
) {
	const identifier = encodeURIComponent(initials);
	return source === "timetables"
		? `/timetables/staff/${identifier}`
		: `/staff/${identifier}/timetable`;
}
